module.exports = __webpack_public_path__ + "media/images/shark/SharkMainImage-p-1080-0feaffbda183cc66997a20f4fd998549.jpg";